import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";

const COOKIE_CONSENT_KEY = "cookie_consent";

export function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "accepted");
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-consent-title"
      aria-describedby="cookie-consent-description"
      className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg animate-fade-in"
    >
      <div className="container py-4 md:py-5">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p id="cookie-consent-description" className="text-sm text-muted-foreground flex-1">
            This website uses essential cookies to ensure it functions properly.
          </p>
          <Button
            onClick={handleAccept}
            className="bg-gradient-hero shadow-button hover:shadow-lg shrink-0"
          >
            OK
          </Button>
        </div>
      </div>
    </div>
  );
}
